import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "col-12 p-0" }
const _hoisted_4 = { class: "login-card" }
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group mb-0" }
const _hoisted_9 = { class: "text-end mt-3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "mt-4 mb-0 text-center" }
const _hoisted_12 = { class: "mt-2 mb-0 text-center" }

import { ref, onMounted } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'verifyOtpPage',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const toaster = createToaster({});
const router = useRouter();
const route = useRoute();

const email = ref<string>("");
const otp = ref<string>("");
const isSubmitting = ref<boolean>(false);

onMounted(() => {
    // Get email from query parameters
    if (route.query.email) {
        email.value = route.query.email as string;
    } else {
        // Redirect to forgot password page if no email is provided
        router.push('/auth/forgot-password');
    }
});

async function verifyOTP() {
    if (!otp.value) {
        toaster.show("Please enter the OTP", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    isSubmitting.value = true;
    try {
        const response = await axios.post(`${baseUrl}api/user/verify-reset-otp`, {
            email: email.value,
            otp: otp.value
        });

        toaster.show("OTP verified successfully", {
            theme: 'outline',
            position: 'top-right',
            icon: 'check',
            type: 'success',
            duration: 2000
        });

        // Store the reset token and redirect to reset password page
        const resetToken = response.data.resetToken;
        router.push({
            name: 'resetPassword',
            query: { 
                email: email.value,
                token: resetToken
            }
        });
    } catch (error: any) {
        console.error('Error verifying OTP:', error);
        toaster.show(error.response?.data?.message || "Invalid or expired OTP. Please try again.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
    } finally {
        isSubmitting.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "theme-form",
                onSubmit: _withModifiers(verifyOTP, ["prevent"])
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-center" }, "Verify OTP", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-center" }, "Enter the OTP sent to your email", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "col-form-label" }, "Email Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    class: "form-control",
                    type: "email",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "col-form-label" }, "OTP", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otp).value = $event)),
                    class: "form-control",
                    type: "text",
                    placeholder: "Enter OTP",
                    required: "",
                    maxlength: "6"
                  }, null, 512), [
                    [_vModelText, otp.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block w-100",
                      type: "submit",
                      disabled: isSubmitting.value
                    }, _toDisplayString(isSubmitting.value ? 'Verifying...' : 'Verify OTP'), 9, _hoisted_10)
                  ])
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/forgot-password"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Resend OTP ")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("p", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/login"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode(" Back to Login ")
                    ])),
                    _: 1
                  })
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})